export const hitsPerPageOptions = [
  { value: 3, label: '3 / Page' },
  { value: 10, label: '10 / Page' },
  { value: 20, label: '20 / Page' },
  { value: 50, label: '50 / Page' },
];
